import { Component, Input, ViewChild } from '@angular/core'
import { ButtonComponent, ButtonDisplayType, ButtonSize, IconComponent } from '@ftr/foundation'
import { Observable } from 'rxjs'
import { DropdownMenuComponent } from '../dropdown-menu'
import { StaticMenuItem } from '../static-menu-item'

@Component({
  selector: 'ftr-action-dropdown-menu',
  templateUrl: './action-dropdown-menu.component.html',
  styleUrls: ['./action-dropdown-menu.component.css'],
  standalone: true,
  imports: [ButtonComponent, DropdownMenuComponent, IconComponent],
})
export class ActionDropdownMenuComponent {
  @Input() ariaLabel = 'dropdown menu'
  @Input() menuItems?: Observable<StaticMenuItem[]>
  @Input() routerLinkActiveExact: boolean = true

  @ViewChild(DropdownMenuComponent)
  dropdown: DropdownMenuComponent

  isDropdownOpen = false

  readonly buttonDisplayType = ButtonDisplayType
  readonly buttonSize = ButtonSize

  setOpenState(value: boolean): void {
    this.isDropdownOpen = value
  }

  toggle(): void {
    this.dropdown.toggle()
  }
}
